import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { IProductMessageByViewport } from "@faire/web-api--source/indigofair/retailer/IProductMessageByViewport";
import { useMemo } from "react";
import { Viewport } from "@faire/web--source/ui/hooks/viewport-utils/viewport-utils";
const mapProductMessageByViewport = (
  banner: IProductMessageByViewport,
  viewport: Viewport
) => {
  switch (true) {
    case viewport.isDesktopAndAbove:
      if (banner.desktop_and_above) {
        return banner.desktop_and_above;
      }

      if (banner.tablet_and_above) {
        return banner.tablet_and_above;
      }

      return banner.mobile_and_above;
    case viewport.isTabletAndAbove:
      if (banner.tablet_and_above) {
        return banner.tablet_and_above;
      }

      return banner.mobile_and_above;
    default:
      return banner.mobile_and_above;
  }
};

export const useGetBannerContentByViewport = (
  banners: IProductMessageByViewport[]
) => {
  const viewport = useViewport();

  const bannerContents = useMemo(
    () =>
      banners
        .map((banner) => mapProductMessageByViewport(banner, viewport))
        .filter(isNotUndefined),
    [banners, viewport]
  );

  const bannerNames = useMemo(
    () => bannerContents.map((banner) => banner?.campaign_name ?? ""),
    [bannerContents]
  );

  return { bannerContents, bannerNames };
};
